"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var AccountSettingsForm_module_css_1 = __importDefault(require("./AccountSettingsForm.module.css"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var DesignToolSettings = function () {
    var _a, _b, _c, _d;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var page = (0, useTypedPage_1.default)();
    var _e = (0, react_1.useState)(false), saving = _e[0], setSaving = _e[1];
    var _f = (0, react_1.useState)("#"), primaryColor = _f[0], setPrimaryColor = _f[1];
    var _g = (0, react_1.useState)("#"), secondaryColor = _g[0], setSecondaryColor = _g[1];
    var accountSettings = { colorPalette: ["#E2EAC2", "#165152", "#C1C6CA", "#D1102B", "#FE4F00", "#F8DD01", "#FFC525", "#653C20", "#009843", "#000000", "#FFFFFF", "#056647", "#071F5D", "#0082CD", "#0099A7", "#783DBE", "#E51994", "#7B2F3C"] };
    var form = (0, inertia_react_1.useForm)({
        accountSettings: accountSettings,
    });
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var account, accountSettingsWithColorPalette;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getAccountByAccountId(page.props.session.current_account.id)];
                    case 1:
                        account = _a.sent();
                        accountSettingsWithColorPalette = JSON.parse(account.account_settings);
                        if (accountSettingsWithColorPalette === null) {
                            accountSettingsWithColorPalette = accountSettings;
                        }
                        else if (!Object.prototype.hasOwnProperty.call(accountSettingsWithColorPalette, "colorPalette")) {
                            accountSettingsWithColorPalette.colorPalette = accountSettings.colorPalette;
                        }
                        form.setData({
                            accountSettings: accountSettingsWithColorPalette
                        });
                        setPrimaryColor(accountSettingsWithColorPalette.colorPalette[0].toUpperCase());
                        setSecondaryColor(accountSettingsWithColorPalette.colorPalette[1].toUpperCase());
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var parseColorValue = function (colorValue) {
        if (!colorValue.startsWith("#"))
            colorValue = "#" + colorValue;
        colorValue = colorValue.padEnd(7, "0");
        return colorValue;
    };
    var setColorPalette = function (index, colorValue) {
        if (!colorValue.startsWith("#"))
            colorValue = "#" + colorValue;
        var settings = form.data.accountSettings;
        settings.colorPalette[index] = colorValue.substring(0, 7);
        form.setData("accountSettings", settings);
    };
    var changePrimaryColor = function (event) {
        var color = parseColorValue(event.target.value);
        setPrimaryColor(event.target.value);
        setColorPalette(0, color);
    };
    var changeSecondaryColor = function (event) {
        var color = parseColorValue(event.target.value);
        setSecondaryColor(event.target.value);
        setColorPalette(1, color);
    };
    var changeColorPalette = function (event, index) {
        var color = parseColorValue(event.target.value);
        setColorPalette(index, color);
    };
    var changeDefaultAppLanguage = function (event) {
        var settings = form.data.accountSettings;
        settings.defaultAppLanguage = event.target.value;
        form.setData("accountSettings", settings);
    };
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSaving(true);
            e.preventDefault();
            ApiManager_1.default.updateAccountSettings(form.data.accountSettings).then(function () {
                setSaving(false);
            });
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement("form", { onSubmit: onSubmit },
        react_1.default.createElement("div", { id: AccountSettingsForm_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-6" },
                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Default settings"))),
                    react_1.default.createElement("span", null, "App language"),
                    react_1.default.createElement("div", { className: "mt-3" },
                        react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                                {
                                    permission: "edit-account",
                                    children: (react_1.default.createElement(q_play_components_1.Select, { style: { width: "50%" }, onChange: changeDefaultAppLanguage, value: form.data.accountSettings.defaultAppLanguage, "data-cy": "defaultAppLanguage" },
                                        react_1.default.createElement("option", { value: "en" }, "English"),
                                        react_1.default.createElement("option", { value: "da" }, "Danish")))
                                },
                                {
                                    permission: "see-account-settings",
                                    children: (react_1.default.createElement(q_play_components_1.Select, { style: { width: "50%" }, value: form.data.accountSettings.defaultAppLanguage, "data-cy": "defaultAppLanguage", disabled: true },
                                        react_1.default.createElement("option", { value: "en" }, "English"),
                                        react_1.default.createElement("option", { value: "da" }, "Danish")))
                                }
                            ] }))),
                react_1.default.createElement("div", { className: "col-6" },
                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title, style: { marginBottom: "0px" } },
                        react_1.default.createElement("span", null, t("Brand identity"))),
                    react_1.default.createElement("span", null, t("Account theming description")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "mb-2 mt-3" },
                            react_1.default.createElement("span", { className: "ns-font-family-bold ns-font-size-15", style: { color: "#161819", lineHeight: "29px" } }, t("Colors"))),
                        react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                                {
                                    permission: "edit-account",
                                    children: (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement("div", { className: "d-flex flex-nowrap align-items-center" },
                                            react_1.default.createElement("input", { type: "color", onChange: changePrimaryColor, value: (_a = form.data.accountSettings) === null || _a === void 0 ? void 0 : _a.colorPalette[0], className: AccountSettingsForm_module_css_1.default.mainColors }),
                                            react_1.default.createElement(q_play_components_1.Input, { value: primaryColor, onChange: changePrimaryColor, style: { width: "160px", marginRight: "12px", marginLeft: "10px" }, className: "ns-rounded-small", dataCy: "primaryColor" }),
                                            react_1.default.createElement("span", null, t("Primary color"))),
                                        react_1.default.createElement("div", { className: "d-flex flex-nowrap align-items-center mt-3" },
                                            react_1.default.createElement("input", { type: "color", onChange: changeSecondaryColor, value: (_b = form.data.accountSettings) === null || _b === void 0 ? void 0 : _b.colorPalette[1], className: AccountSettingsForm_module_css_1.default.mainColors }),
                                            react_1.default.createElement(q_play_components_1.Input, { value: secondaryColor, onChange: changeSecondaryColor, style: { width: "160px", marginRight: "12px", marginLeft: "10px" }, className: "ns-rounded-small" }),
                                            react_1.default.createElement("span", null, t("Secondary color")))))
                                },
                                {
                                    permission: "see-account-settings",
                                    children: (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement("div", { className: "d-flex flex-nowrap align-items-center" },
                                            react_1.default.createElement("input", { type: "color", value: (_c = form.data.accountSettings) === null || _c === void 0 ? void 0 : _c.colorPalette[0], className: AccountSettingsForm_module_css_1.default.mainColors, style: { cursor: "default" }, disabled: true }),
                                            react_1.default.createElement(q_play_components_1.Input, { value: primaryColor, style: { width: "160px", marginRight: "12px", marginLeft: "10px", cursor: "default" }, className: "ns-rounded-small", dataCy: "primaryColor", disabled: true }),
                                            react_1.default.createElement("span", null, t("Primary color"))),
                                        react_1.default.createElement("div", { className: "d-flex flex-nowrap align-items-center mt-3" },
                                            react_1.default.createElement("input", { type: "color", value: (_d = form.data.accountSettings) === null || _d === void 0 ? void 0 : _d.colorPalette[1], className: AccountSettingsForm_module_css_1.default.mainColors, style: { cursor: "default" }, disabled: true }),
                                            react_1.default.createElement(q_play_components_1.Input, { value: secondaryColor, style: { width: "160px", marginRight: "12px", marginLeft: "10px", cursor: "default" }, className: "ns-rounded-small", disabled: true }),
                                            react_1.default.createElement("span", null, t("Secondary color")))))
                                }
                            ] }),
                        react_1.default.createElement("div", { className: "mb-2 mt-3" },
                            react_1.default.createElement("span", { className: "ns-font-family-bold ns-font-size-15", style: { color: "#161819", lineHeight: "29px" } }, t("Color palette"))),
                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.colorPalette },
                            react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                                    {
                                        permission: "edit-account",
                                        children: (react_1.default.createElement(react_1.default.Fragment, null, form.data.accountSettings.colorPalette.map(function (color, index) {
                                            if (index === 0 || index === 9) {
                                                return (react_1.default.createElement("div", { key: index, className: AccountSettingsForm_module_css_1.default.colorPaletteColor, style: { backgroundColor: color, cursor: "default", border: "var(--ns-border)" } }));
                                            }
                                            if (index === 1 || index === 10) {
                                                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                                                    react_1.default.createElement("div", { key: index, className: AccountSettingsForm_module_css_1.default.colorPaletteColor, style: { backgroundColor: color, marginRight: "3px", cursor: "default", border: "var(--ns-border)" } }),
                                                    react_1.default.createElement("div", { style: { height: "25px", width: "1px", borderRight: "solid 1px #D2D2D280", marginRight: "3px" } })));
                                            }
                                            return (react_1.default.createElement("input", { type: "color", onChange: function (event) { return changeColorPalette(event, index); }, key: index, className: AccountSettingsForm_module_css_1.default.colorPaletteColor, value: color }));
                                        })))
                                    },
                                    {
                                        permission: "see-account-settings",
                                        children: (react_1.default.createElement(react_1.default.Fragment, null, form.data.accountSettings.colorPalette.map(function (color, index) {
                                            if (index === 0 || index === 9) {
                                                return (react_1.default.createElement("div", { key: index, className: AccountSettingsForm_module_css_1.default.colorPaletteColor, style: { backgroundColor: color, cursor: "default", border: "var(--ns-border)" } }));
                                            }
                                            if (index === 1 || index === 10) {
                                                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                                                    react_1.default.createElement("div", { key: index, className: AccountSettingsForm_module_css_1.default.colorPaletteColor, style: { backgroundColor: color, marginRight: "3px", cursor: "default", border: "var(--ns-border)" } }),
                                                    react_1.default.createElement("div", { style: { height: "25px", width: "1px", borderRight: "solid 1px #D2D2D280", marginRight: "3px" } })));
                                            }
                                            return (react_1.default.createElement("input", { type: "color", disabled: true, key: index, style: { cursor: "default" }, className: AccountSettingsForm_module_css_1.default.colorPaletteColor, value: color }));
                                        })))
                                    }
                                ] })))))),
        react_1.default.createElement("div", { id: AccountSettingsForm_module_css_1.default.buttonContainer },
            react_1.default.createElement("div", { style: { display: "flex" } },
                react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                        {
                            permission: "edit-account",
                            children: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), isDisabled: saving, dataCy: "saveAccountSettingsButton" })))
                        },
                        {
                            permission: "see-account-settings",
                            children: (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), isDisabled: true, dataCy: "saveAccountSettingsButton" })))
                        }
                    ] })))));
};
exports.default = DesignToolSettings;
